import React, { useState, useEffect } from "react";
import Price from './price'
import Stock from './stock'


/*
*
* this one is very complex:
we have 4 state registers:

selectedVariation: the whole object for the variation we will add to basket
selectedTaxonomy: the ID number of the taxonomy selected form the first dropdown
availableTaxonomyVariations: an array containing the ID numbers of the variations available in the selectedTaxonomy
sorted_variations: an object with a different data structure, containing an array of 2 items: (attribute)taxonomy, child (attribute)taxonomies and variations for those

how it works is:
on page load, we take the all_attributes prop (this is all of the taonomies of type=attribute) and we turn them into the sorted_variations data-structure
we then set the 'first dropdown' (selectedTaxonomy and AvailableTaxonomyVariations) to the first child of the first taxonomy [eg we pre-select the value from the first item on the first list]
when ever the store_first_dropdown function is called, it sets the  selectedTaxonomy and AvailableTaxonomyVariations and also sets the second dropdown to have the corss-referenced taxonomies inside
eg: if the taxonomy selected from the first dropdown has variations 1,2,3,4, we set the second dropdown to have all the taxonomy-names from the second array in sorted_variations which contain the variations 1,2,3,4


doing it this way means that the whole component is still dynaimc, and all the names, prices, etc update on each dropdown change, 
and the properties of the second dropbox are automatically filtered out based ont he selection from the first dropdown


the drawback is that I had to add this explanation, and the code is far from readable


**** IT ALSO WORKS IF THERE ARE NO ATTRIBUTES AND YOU JUST WANT A SINGLE LIST TO SELECT FROM
**** ITS LIMITED TO TWO DROPDOWNS AS ITS MEGA COMPLEX
*
*/

function Variations({ item, all_attributes, loading, config }) {

    const [selectedVariation, setSelectedVariation] = useState(item.variations[0]);
    const [selectedTaxonomy, setSelectedTaxonomy] = useState(0);
    const [availableTaxonomyVariatons, setAvailableTaxonomyVariatons] = useState([]);
    const [sorted_variations, setSorted_variations] = useState();


    const search_object = (haystack, needle) => {
        return haystack.filter(obj => {
            return obj.id === needle;
        })[0];
    }

    const store_first_dropdown = (taxonomy, sorted_variations, product) => {
        // store our selected taxonomy here
        setSelectedTaxonomy(taxonomy)
        var selected_taxonomy_index = sorted_variations[0].taxonomies.findIndex((element) => element.id == taxonomy)

        // store the variations available here
        setAvailableTaxonomyVariatons(sorted_variations[0].taxonomies[selected_taxonomy_index].variations)

        // reset the second dropdown if we chnage the first dropdown
        var variation_id = sorted_variations[0].taxonomies[selected_taxonomy_index].variations[0]
        store_second_dropdown(variation_id, product)
    }
    const store_second_dropdown = (variation_id, product) => {
        var result = product.variations.filter(obj => {
            return obj.id == variation_id
        })

        // store our selected variation here
        setSelectedVariation(result[0])
    }

    const create_filtered_tree = (variations) => {
        var result = []

        // loop each of our varations
        variations.forEach((variation) => {
            // loop the taxonomies list inside each variation
            variation.variationtaxonomieslist.map(function (obj) {
                // check we have one already
                var index = result.findIndex((element) => element.id == obj.parent_id);

                // add to our result array
                if (index >= 0) {
                    // search and see if we have the taxonomy in the tree already
                    var tax_index = result[index].taxonomies.findIndex(taxonomy => taxonomy.id == obj.id);
                    if (tax_index >= 0) {
                        // just add our variation to the array
                        result[index].taxonomies[tax_index].variations.push(variation.id)
                    } else {
                        // doesnt exist, create an object
                        var temp = {
                            id: obj.id,
                            name: obj.name,
                            variations: [
                                variation.id,
                            ]
                        }
                        // push up
                        result[index].taxonomies.push(temp)
                    }
                } else {
                    // check if we have a value
                    // get the parent taxonomy name
                    var needle = search_object(all_attributes, obj.parent_id)
                    // doesnt exist, create an object
                    var temp = {
                        id: obj.parent_id,
                        name: needle.name,
                        taxonomies: [{
                            id: obj.id,
                            name: obj.name,
                            variations: [
                                variation.id,
                            ]
                        }],

                    }
                    result.push(temp)
                }

            })

        })
        // in here I set a value, for the first child of the first array (eg the first item on the first dropdown is pre-selected)
        if (selectedTaxonomy == 0) {
            store_first_dropdown(result[0].taxonomies[0].id, result, item)
        }
        setSorted_variations(result)
    }
    // store these for later so we can process them

    useEffect(() => {


        // because item changes, set the preferred one
        setSelectedVariation(item.variations[0])
        // only do this if we have attribute taxonomies
        if (item.variations[0].variationtaxonomieslist && item.variations[0].variationtaxonomieslist.length > 0) {
            create_filtered_tree(item.variations)
        }
    }, [item]);

    return (

        <>
            <Stock variation={selectedVariation} config={config}></Stock>


            {(item && item.variations && item.variations.length > 0) ? (
                // we have variations, check if we have the sorted variations, and that our item has more than one
                (sorted_variations && item.variations[0].variationtaxonomieslist && item.variations[0].variationtaxonomieslist.length > 1) ? (
                    <>

                        <div className="lg:grid lg:grid-cols-2 lg:gap-4 mb-6">
                            <div key={sorted_variations[0].id} className="mb-3 lg:mb-0">
                                <label className="field-label">
                                    <span className="mb-2 block">{sorted_variations[0].name}</span>
                                    <select
                                        className="dropdown-field"
                                        onChange={(e) => {
                                            store_first_dropdown(e.target.value, sorted_variations, item);
                                        }}
                                        defaultValue={selectedTaxonomy}
                                    >
                                        {sorted_variations[0].taxonomies.map((option) => (
                                            <option key={option.id} value={option.id}>{option.name}</option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                            <div key={sorted_variations[1].id} className="mb-3 lg:mb-0">
                                <label className="field-label">
                                    <span className="mb-2 block">{sorted_variations[1].name}</span>
                                    <select
                                        className="dropdown-field"
                                        onChange={(e) => {
                                            store_second_dropdown(e.target.value, item);
                                        }}
                                    >
                                        {sorted_variations[1].taxonomies.map((taxonomy) => (
                                            taxonomy.variations.map((variation) => (
                                                (availableTaxonomyVariatons.find(element => element == variation)) ? (
                                                    <option key={variation} value={variation}>{taxonomy.name}</option>
                                                ) : (
                                                    ''
                                                )
                                            ))
                                        ))}
                                    </select>
                                </label>
                            </div>
                        </div>
                    </>
                ) : (

                    // check that we have sorted variations, and that our item has one variation
                    (sorted_variations && item.variations[0].variationtaxonomieslist && item.variations[0].variationtaxonomieslist.length == 1) ? (
                        <>

                            <div className="lg:grid lg:grid-cols-1 lg:gap-4 mb-6">
                                <div key={sorted_variations[0].id} className="mb-3 lg:mb-0">
                                    <label className="field-label">
                                        <span className="mb-2 block">{sorted_variations[0].name}</span>
                                        <select
                                            className="dropdown-field"
                                            onChange={(e) => {
                                                store_second_dropdown(e.target.value, item);
                                            }}
                                        >
                                            {/* output them all */}
                                            {sorted_variations[0].taxonomies.map((taxonomy) => (
                                                taxonomy.variations.map((variation) => (
                                                    <option key={variation} value={variation}>{taxonomy.name}</option>
                                                ))
                                            ))}
                                        </select>
                                    </label>
                                </div>
                            </div>
                        </>
                    ) : (
                        (item.variations.length > 1) ? (
                            <div className="lg:grid lg:grid-cols-1 lg:gap-4 mb-6">
                                <div className="mb-3 lg:mb-0">
                                    <label className="field-label">
                                        <span className="mb-2 block">Options</span>
                                        <select
                                            className="dropdown-field"
                                            onChange={(e) => {
                                                store_second_dropdown(e.target.value, item);
                                            }}
                                        >
                                            {item.variations.map((option) => (
                                                <option key={option.id} value={option.id}>{option.name}</option>
                                            ))}
                                        </select>
                                    </label>
                                </div>
                            </div>
                        ) : ('')
                    )
                )
            ) : ('')}

            {(loading) ? (<span className="text-sm text-gray-500 italic">Loading prices..</span>) : (<Price variation={selectedVariation} item={item}></Price>)}
        </>
    );
}

export default Variations;